import {Box, BoxProps, Typography} from "@mui/material";
import {FC} from "react";
import {makeStyles} from "tss-react/mui";
import {palette} from "@/constants";
import LeaderboardCard from "@/app2/components/LeaderboardCard";
import StreakCard from "@/app2/components/dailyStreak/StreakCard";
import {useDevCycleSdk} from "@/app2/shared/hooks";

type IProps = {enableDayStreak?: boolean, applyNewTitleStyle?: boolean } & BoxProps;

const useStyles = makeStyles<{applyNewTitleStyle?: boolean}>()((theme, {applyNewTitleStyle}) => ({
	pageTitle: {
		justifyContent: "space-between",
		display: "flex",
		flexDirection: "column",
		marginTop: applyNewTitleStyle ? "0" : "40px",
		borderBottom: !applyNewTitleStyle ? "1px solid " + palette.grey10 : "none",
		padding: "20px 0",
		marginBottom: "30px",
		[theme.breakpoints.down("sm")]: {
			borderBottom: "none",
			margin: applyNewTitleStyle ? "0 10px 0 10px" : "10px 10px 0 10px",
			padding: "10px 0 0 0"
		},
		[theme.breakpoints.down("lg")]: {
			padding: "10px"
		}
	},
	title: {
		fontWeight: 700,
		fontSize: "62px",
		[theme.breakpoints.down("sm")]: {
			fontSize: "32px"
		}

	},
	newTitle: {
		fontWeight: 400,
		fontSize: "34px"
	},
	subTitle: {
		fontSize: "20px",
		color: palette.grey80,
		marginBottom: "22px"
	}
}));

export const PageTitle: FC<IProps> = ({title, enableDayStreak, applyNewTitleStyle, ...boxProps}) => {
	const {classes} = useStyles({applyNewTitleStyle});
	const {leaderboards} = useDevCycleSdk();

	return (
		<Box className={classes.pageTitle} {...boxProps}>
			<Box sx={{display: "flex", justifyContent: "space-between", marginBottom: "10px"}}>
				<Typography
					data-test-id="pagetitle-title-txt"
					className={applyNewTitleStyle ? classes.newTitle : classes.title}
				>
					{title}
				</Typography>
			</Box>
			{enableDayStreak &&
				(leaderboards ? (
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							flexWrap: "nowrap",
							gap: 2,
							width: "100%",
							alignItems: "stretch"
						}}
					>
						<Box
							sx={{
								flex: 1,
								minWidth: 0,
								display: "flex"
							}}
						>
							<StreakCard />
						</Box>
						<Box
							sx={{
								flex: 1,
								minWidth: 0,
								display: "flex"
							}}
						>
							<LeaderboardCard />
						</Box>
					</Box>
				) : (
					<StreakCard />
				))}
		</Box>
	);
};